export const DEFAULT_SERIALIZER = 'with_events'
